/*
 * Author: Harper Yan
 * File Created: Friday, 25-03-28 01:58 pm
 * Last Modified: Friday, 25-03-28 01:58 pm, by Harper Yan
 */

import { StoreApi, UseBoundStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

export type CreateActions<State, Action> = (
  set: (
    partial:
      | Partial<State & Action>
      | ((state: State & Action) => Partial<State & Action>),
    replace?: boolean
  ) => void,
  get: () => State & Action
) => Action;

export const createStoreActions = <
  State extends object,
  Actions extends object,
>(
  actionLogic: CreateActions<State, Actions> // the specific logic for the actions
) => {
  return actionLogic;
};

export const generateUseShallow = <
  State extends Record<string, any>,
  Actions extends Record<string, any>,
  Store = State & Actions,
>(
  useStore: UseBoundStore<StoreApi<Store>>
) => {
  const useState = <T extends keyof Store>(keys?: T[]): Pick<Store, T> => {
    if (!keys?.length) {
      return useStore();
    }
    return useStore(
      useShallow((s) => {
        const res = {} as Pick<Store, T>;
        keys.forEach((k) => {
          res[k] = s[k];
        });
        return res;
      })
    );
  };

  return useState;
};
